/**
 * @namespace COMMON
 */
const COMMON = {};

/**
 * 共通モジュール
 * @constructor Util
 */
COMMON.Util = function () {
  this.$win = $(window);
  this.ua = navigator.userAgent.toLowerCase();
  this.ver = window.navigator.appVersion.toLowerCase();
  this.url = location.href;
  this.mq = window.matchMedia("(min-width: 601px)");
  this.hash = location.hash;
  this.viewProductRecentlyCookie = "recently-viewed-products";
  this.productVendors = COMMON_SHOPIFY_PROPERTY.productVendors.reduce(
    (target, obj, index) => {
      index = obj.vendor_id;
      target[index] = obj.name;

      return target;
    },
    {}
  );
};

COMMON.Util.prototype = {
  deviceChecker: function () {
    if (this.ua.indexOf("iphone") !== -1) {
      return "iphone";
    } else if (this.ua.indexOf("ipod") !== -1) {
      return "ipod";
    } else if (this.ua.indexOf("ipad") !== -1) {
      return "ipad";
    } else if (
      this.ua.indexOf("android") !== -1 &&
      this.ua.indexOf("mobile") !== -1
    ) {
      return "android mobile";
    } else if (
      this.ua.indexOf("android") !== -1 &&
      this.ua.indexOf("mobile") === -1
    ) {
      return "android tablet";
    } else if (this.ua.indexOf("windows phone") !== -1) {
      return "windows phone";
    } else {
      return "desktop";
    }
  },
  isRangeSP: function () {
    const clientW = document.documentElement.clientWidth;
    const winW = window.innerWidth
      ? window.innerWidth
      : this.$win.width()
      ? this.$win.width()
      : clientW;

    return winW <= 768 ? true : false;
  },
  isMobile: function () {
    return this.deviceChecker() === "iphone" ||
      this.deviceChecker() === "ipod" ||
      this.deviceChecker() === "android mobile" ||
      this.deviceChecker() === "windows phone"
      ? true
      : false;
  },
  isTablet: function () {
    return this.deviceChecker() === "ipad" ||
      this.deviceChecker() === "android tablet"
      ? true
      : false;
  },
  isDesktop: function () {
    return !this.isMobile() && !this.isTablet() ? true : false;
  },
  isWindowSizeWatch: function (callback) {
    let resize = false;

    window.addEventListener("resize", function () {
      // リサイズされている間は何もしない
      if (!resize) {
        clearTimeout(resize);
      }

      resize = setTimeout(function () {
        callback();
      }, 1000);
    });
  },
  getUrlParam: function (name, url) {
    if (!url) url = window.location.href;

    name = name.replace(/[\[\]]/g, "\\$&");

    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
    const results = regex.exec(url);

    if (!results) return null;
    if (!results[2]) return "";

    return decodeURIComponent(results[2].replace(/\+/g, " "));
  },
  ajaxGetShopifyProductData: async function (token, query, limit) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "POST",
        url: "/api/" + COMMON_SHOPIFY_PROPERTY.apiVersion + "/graphql.json",
        dataType: "json",
        contentType: "application/json",
        headers: {
          "X-Shopify-Storefront-Access-Token": token,
        },
        data: JSON.stringify({
          query: this.setShopifyProductQuery(limit, query),
        }),
      })
        .done(function (data) {
          resolve(data.data.products.edges);
        })
        .fail(function () {
          reject();
        });
    });
  },
  makeQuery: function (arrays) {
    let query = "";

    for (const array of arrays) {
      query += `(tag:${array}) OR `;
    }

    return query;
  },
  setShopifyProductQuery: function (limit, query) {
    return `
      {
        products(first: ${limit}, query: "${query}") {
          edges {
            node {
              id
              variants(first: 10) {
                edges {
                  node {
                    id
                  }
                }
              }
              handle
              prefecture: metafield(namespace: "custom", key: "production_area_prefecture") {
                value
              }
              listDiscountRate: metafield(namespace: "custom", key: "list_discount_rate") {
                value
              }
              title
              compareAtPriceRange {
                maxVariantPrice {
                  amount
                }
                minVariantPrice {
                  amount
                }
              }
              priceRange {
                maxVariantPrice {
                  amount
                }
                minVariantPrice {
                  amount
                }
              }
              listPoint: metafield(namespace: "custom", key: "list_point") {
                value
              }
              pointMultiplier: metafield(namespace: "custom", key: "point_multiplier") {
                value
              }
              shippingId: metafield(namespace: "custom", key: "shipping_id") {
                value
              }
              campaignPricePeriod: metafield(namespace: "custom", key: "campaign_price_period") {
                value
              }
              promotionTag: metafield(namespace: "custom", key: "promotion_tag") {
                value
              }
              listThumb: metafield(namespace: "custom", key: "list_thumb") {
                value
              }
              hidden: metafield(namespace: "seo", key: "hidden") {
                value
              }
              shopRanking: metafield(namespace: "custom", key: "shop_ranking") {
                value
              }
              shopHandle: metafield(namespace: "custom", key: "shop_handle") {
                value
              }
              shopName: metafield(namespace: "custom", key: "shop_handle") {
                reference {
                  ... on Page {
                    id
                    handle
                    title
                    metafield(namespace: "custom", key: "shop_name") {
                      value
                    }
                  }
                }
              }
            }
          }
        }
      }
    `;
  },
  getPrefectureName: function (prefecture) {
    let data = prefecture.trim();

    if (data == "東京都") {
      return data.replace("都", "");
    } else {
      const reps = ["県", "府"];

      for (const rep of reps) {
        data = data.replace(rep, "");
      }

      return data;
    }
  },
  convertShopifyProductData: function (
    data,
    cookies = null,
    mode = null,
    isAwooAPI = false
  ) {
    let products = [];

    for (const obj of data) {
      const product = obj.node;

      let hidden = false;

      if (product.hidden && product.hidden.value === "1") {
        hidden = true;
      }

      if (hidden) continue;

      let tags = null;

      if (product.promotionTag && product.promotionTag.value != "[]") {
        const text = unescape(product.promotionTag.value);
        tags = text.slice(1).slice(0, -1).replaceAll('"', "").split(",");
      }

      let shopName = null;

      if (product.shopName.reference) {
        shopName = product.shopName.reference.title;
      }

      const processedData = {
        id: parseInt(product.id.replace("gid://shopify/Product/", "")),
        variantId: product.variants.edges[0]
          ? parseInt(
              product.variants.edges[0].node.id.replace(
                "gid://shopify/ProductVariant/",
                ""
              )
            )
          : null,
        url: `/products/${product.handle}`,
        prefecture: product.prefecture
          ? this.getPrefectureName(product.prefecture.value)
          : null,
        listDiscountRate: product.listDiscountRate
          ? product.listDiscountRate.value
          : null,
        title: product.title,
        compareAtPriceMin: parseInt(
          product.compareAtPriceRange.minVariantPrice.amount
        ),
        compareAtPriceMinF: parseInt(
          product.compareAtPriceRange.minVariantPrice.amount
        ).toLocaleString(),
        compareAtPriceMax: parseInt(
          product.compareAtPriceRange.maxVariantPrice.amount
        ),
        compareAtPriceMaxF: parseInt(
          product.compareAtPriceRange.maxVariantPrice.amount
        ).toLocaleString(),
        priceMin: parseInt(product.priceRange.minVariantPrice.amount),
        priceMinF: parseInt(
          product.priceRange.minVariantPrice.amount
        ).toLocaleString(),
        priceMax: parseInt(product.priceRange.maxVariantPrice.amount),
        priceMaxF: parseInt(
          product.priceRange.maxVariantPrice.amount
        ).toLocaleString(),
        listPoint: product.listPoint ? product.listPoint.value : null,
        shippingId: product.shippingId
          ? parseInt(product.shippingId.value)
          : null,
        campaignPricePeriod: product.campaignPricePeriod
          ? product.campaignPricePeriod.value
          : null,
        promotionTag: tags,
        listThumb: product.listThumb ? product.listThumb.value : null,
        shopRanking: product.shopRanking
          ? parseInt(product.shopRanking.value)
          : 9999999,
        hidden: hidden,
        placeholderPath: COMMON_SHOPIFY_PROPERTY.logoPath,
        shopName: shopName,
        mode: mode ? mode : "",
      };

      products.push(processedData);
    }

    if (cookies) {
      // 商品情報のソート
      const sortKey = cookies.map((cookie) => {
        return parseInt(cookie.replace("gid:", ""));
      });

      if (isAwooAPI) {
        products.sort((x, y) => {
          return sortKey.indexOf(x.variantId) - sortKey.indexOf(y.variantId);
        });
      } else {
        products.sort((x, y) => {
          return sortKey.indexOf(x.id) - sortKey.indexOf(y.id);
        });
      }
    }

    return {
      products: products,
    };
  },
  makeShopifyHTMLData: async function (productsData) {
    return new Promise((resolve) => {
      if (productsData.products.length) {
        const output = Handlebars.compile(`
          {{#each products}}
            {{#switch mode }} 
              {{#case 'slide'}}
              <li class="p-slide__item">
                <div class="p-product-card-wrapper--tag">
              {{/case}} 
              {{#case 'col'}}
              <li class="l-col__item">
                <div class="p-product-card-wrapper--tag">
              {{/case}}
              {{#case 'default'}}
              <li class="swiper-slide l-col__item">
                <div class="p-product-card-wrapper--tag">
              {{/case}}
            {{/switch}}
                <a href="{{url}}" class="p-product-card--tag">
                  <div class="p-product-card__img">
                    <div class="p-product-card__tag">
                      <div class="p-product-card__tag__area">
                        <div>
                          <span>{{prefecture}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="p-product-card__figure">
                    {{#if listDiscountRate}}
                    <div class="p-product-card__figure__sale-points">{{listDiscountRate}}</div>
                    {{/if}}
                    {{#if listThumb}}
                    <img src="{{listThumb}}" alt="{{title}}">
                    {{else}}
                    <div class="placeholder">
                      <img src="{{placeholderPath}}" alt="商品画像はありません">
                      <span class="visually-hidden">商品画像はありません</span>
                    </div>
                    {{/if}}
                  </div>
                  <div class="p-product-card__info">
                    <p class="p-product-card__title">{{title}}</p>
                    <div class="p-product-card__price-wrapper">
                      {{#if (or
                        (ne priceMin compareAtPriceMin) (ne priceMax compareAtPriceMax)
                      )}}
                        <p class="p-product-card__price--sale">
                          {{#ifCond priceMin '==' priceMax}}
                            {{priceMaxF}}円<span class="p-product-card__price__tax">（税込）</span>
                          {{else}}
                            {{priceMinF}}円〜{{priceMaxF}}円<span class="p-product-card__price__tax">（税込）</span>
                          {{/ifCond}}
                        </p>
                        <p class="p-product-card__price--original">
                          {{#ifCond compareAtPriceMin '==' compareAtPriceMax}}
                            <s>{{compareAtPriceMaxF}}円</s>
                          {{else}}
                            <s>{{compareAtPriceMinF}}円〜{{compareAtPriceMaxF}}円</s>
                          {{/ifCond}}
                        </p>
                      {{else}}
                        <p class="p-product-card__price">
                          {{#ifCond priceMin '==' priceMax}}
                            {{priceMaxF}}円<span class="p-product-card__price__tax">（税込）</span>
                          {{else}}
                            {{priceMinF}}円〜{{priceMaxF}}円<span class="p-product-card__price__tax">（税込）</span>
                          {{/ifCond}}
                        </p>
                      {{/if}}
                    </div>
                    {{#if listPoint}}
                      <p class="p-product-card__points">
                        {{listPoint}}
                      </p>
                    {{/if}}
                    {{#ifCond shippingId '==' 99}}
                      <p class="p-product-card__shipping-fee">送料無料</p>
                    {{/ifCond}}
                    {{#if campaignPricePeriod}}
                      <p class="p-product-card__sales-date">{{campaignPricePeriod}}</p>
                    {{/if}}
                    {{#if promotionTag}}
                    <ul class="p-product-card__promotion-words">
                      {{#each promotionTag}}
                        <li class="p-product-card__promotion-words__item">{{this}}</li>
                      {{/each}}
                    </ul>
                    {{/if}}
                    {{#if shopName}}
                    <p class="p-product-card__shop">
                      <span>{{shopName}}</span>
                    </p>
                    {{/if}}
                  </div>
                </a>
            {{#switch mode }} 
              {{#case 'slide'}}
                </div>
              </li>
              {{/case}} 
              {{#case 'col'}}
                </div>
              </li>
              {{/case}}
              {{#case 'default'}}
                </div>
              </li>
              {{/case}}
            {{/switch}}
          {{/each}}
        `);
        resolve(output(productsData));
      } else {
        resolve(null);
      }
    });
  },
  makeHtml: function (productsData) {
    let html = '';
    for (const product of productsData) {
      if (!product.mode) html += this.generateProductHTML(product);
    }
    return html;
  },
  generateProductHTML: function (product) {
    let html = '';

    switch (product.mode) {
      case 'slide':
        html += '<li class="p-slide__item"><div class="p-product-card-wrapper--tag">';
      case 'col':
        html += '<li class="l-col__item"><div class="p-product-card-wrapper--tag">';
      default:
        html += '<li class="swiper-slide l-col__item"><div class="p-product-card-wrapper--tag">';
    }
    html += `
        <a href="${product.url}" class="p-product-card--tag">
          <div class="p-product-card__img">
            <div class="p-product-card__tag">
              <div class="p-product-card__tag__area">
                <div>
                  <span>${product.prefecture}</span>
                </div>
              </div>
            </div>
          </div>`;

    html += `<div class="p-product-card__figure">`;  
    if (product.listDiscountRate) html += `<div class="p-product-card__figure__sale-points">${product.listDiscountRate}</div>`;
    if (product.listThumb) html += `<img src="${product.listThumb}}" alt="${product.title}" />`;
    if (!product.listThumb) {
      html += `
        <div class="placeholder">
          <img src="${product.placeholderPath}" alt="商品画像はありません">
          <span class="visually-hidden">商品画像はありません</span>
          </div>`;
    }
    html += `</div>`;
    html += `<div class="p-product-card__info"><p class="p-product-card__title">${product.title}</p>`;

    if (product.priceMin !== product.compareAtPriceMin || product.priceMax !== product.compareAtPriceMax) {
      html += `
        <p class="p-product-card__price--sale">
          ${product.priceMin === product.priceMax ? `${product.priceMaxF}円` : `${product.priceMinF}円〜${product.priceMaxF}円`}
          <span class="p-product-card__price__tax">（税込）</span>
        </p>
        <p class="p-product-card__price--original">
          ${product.compareAtPriceMin === product.compareAtPriceMax ? `<s>${product.compareAtPriceMaxF}円</s>` : `<s>${product.compareAtPriceMinF}円〜${product.compareAtPriceMaxF}円</s>`}
        </p>
      `;
    } else {
      html += `
        <p class="p-product-card__price">
          ${product.priceMin === product.priceMax ? `${product.priceMaxF}円` : `${product.priceMinF}円〜${product.priceMaxF}円`}
          <span class="p-product-card__price__tax">（税込）</span>
        </p>
      `;
    }

    if (product.listPoint) html += `<p class="p-product-card__points">${product.listPoint}</p>`;
    if (product.shippingId == 99 ) html += `<p class="p-product-card__shipping-fee">送料無料</p>`;
    if (product.campaignPricePeriod) html += `<p class="p-product-card__sales-date">${product.campaignPricePeriod}</p>`;
    if (product.promotionTag) {
      html += `<ul class="p-product-card__promotion-words">
        ${product.promotionTag.map(tag => `<li class="p-product-card__promotion-words__item">${tag}</li>`).join('')}
        </ul>`;
    }
    if (product.shopName) html += `<p class="p-product-card__shop"><span>${product.shopName}</span></p>`;

    html += `</div>
        </a>
      </div>
      </li>
    `;
    return html;
  },
};

/**
 * @module
 */
COMMON.module = (function () {
  const u = new COMMON.Util();

  return {
    /**
     * @method initialize
     * - 初期化
     */
    initialize: function () {
      this.addExternalLink();
      this.fixImageMaps();
      this.tabs();
      this.customScrollbar();
      this.customScrollHint();
      this.accordion();
      this.carousel();
      this.smoothScroll();
      this.scrollTop();
    },
    /**
     * @method addBlankLink
     * - 外部リンクの設定
     */
    addExternalLink: function () {
      const links = document.links;

      for (let i = 0, linksLength = links.length; i < linksLength; i++) {
        if (links[i].hostname !== window.location.hostname) {
          links[i].target = "_blank";
          links[i].rel = "noreferrer noopener";
        }
      }
    },
    /**
     * @method fixImageMaps
     * - リサイズ時のイメージマップ調整
     * @requires
     * - Image Map Resizer v1.0.10
     */
    fixImageMaps: function () {
      const imgs = document.querySelectorAll("img[usemap]");

      if (!imgs.length) {
        return;
      }

      window.addEventListener("load", function () {
        imageMapResize();
      });
    },
    /**
     * @method tabs
     * - タブ機能
     * @requires
     * - Tabby v12.0.0
     */
    tabs: function () {
      if (!document.querySelectorAll("[data-tabs]").length) {
        return;
      }

      const tabSelectors = document.querySelectorAll("[data-tabs]");

      for (const [i, tabs] of [...tabSelectors].entries()) {
        tabs.setAttribute(`data-tabs-${i}`, "");
        new Tabby(`[data-tabs-${i}]`);
      }
    },
    /**
     * @method customScrollbar
     * - 画面はみ出し時のスクロールバー機能
     * @requires
     * - SimpleBar.js v5.3.8
     */
    customScrollbar: function () {
      const targetClassName = ".js-scrollbar";

      if (!document.querySelectorAll(targetClassName).length) {
        return;
      }

      Array.prototype.forEach.call(
        document.querySelectorAll(targetClassName),
        (elm) => new SimpleBar(elm, {})
      );
    },
    /**
     * @method customScrollHint
     * - スマホ用のスクロールヒント機能
     * @requires
     * - ScrollHint v1.1.10
     */
    customScrollHint: function () {
      const targetClassName = ".js-scrollable";

      if (!document.querySelectorAll(targetClassName).length) {
        return;
      }

      new ScrollHint(targetClassName, {
        i18n: {
          scrollable: "スクロールできます",
        },
      });
    },
    /**
     * @method accordion
     * - アコーディオン機能
     * @requires
     * - Accordion v3.3.2
     */
    accordion: function () {
      const SP_ONLY_CLASSNAME = "js-accordion-sp-only";
      const settings = [
        {
          className: "." + SP_ONLY_CLASSNAME,
          options: {
            duration: 300,
            showMultiple: true,
          },
        },
        {
          className: ".js-accordion",
          options: {
            duration: 300,
            showMultiple: true,
          },
        },
      ];
      const spOptions = settings[0].options,
        spNodes = document.querySelectorAll("." + SP_ONLY_CLASSNAME),
        spTargets = new Array(spNodes.length).fill(null);
      const media = window.matchMedia("(max-width: 768.99px)");

      settings.forEach((elm) => {
        const target = document.querySelectorAll(elm.className);

        if (!target.length) {
          return;
        } else {
          if (elm.className === "." + SP_ONLY_CLASSNAME) {
            for (let i = 0; i < spNodes.length; i++) {
              spNodes[i].classList.add(SP_ONLY_CLASSNAME + "-" + i);
            }

            const checkBreakpoint = (e) => {
              for (let i = 0; i < spTargets.length; i++) {
                if (e.matches) {
                  spTargets[i] = new Accordion(
                    "." + SP_ONLY_CLASSNAME + "-" + i,
                    spOptions
                  );
                } else if (spTargets[i]) {
                  spTargets[i].detachEvents();
                }
              }
            };

            media.addListener(checkBreakpoint);
            checkBreakpoint(media);
          } else {
            const targets = document.querySelectorAll(elm.className);

            for (let i = 0; i < targets.length; i++) {
              targets[i].classList.add(
                elm.className.replace(".", "") + "-" + i
              );
              new Accordion(elm.className + "-" + i, elm.options);
            }
          }
        }
      });
    },
    /**
     * @method carousel
     * - カルーセル機能
     * @requires
     * - Swiper v8.4.2
     */
    carousel: function () {
      const settings = [
        {
          className: "js-carousel--col1",
          options: {
            centeredSlides: false,
            speed: 700,
            grabCursor: true,
            watchSlidesProgress: true,
            slidesPerView: 3,
            spaceBetween: 16,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            breakpoints: {
              769: {
                slidesPerView: 1,
              },
            },
          },
          isPCOnly: true,
        },
      ];

      settings.forEach((elm) => {
        const nodes = document.querySelectorAll("." + elm.className);
        const targets = new Array(nodes.length).fill(null);

        if (!nodes.length) {
          return;
        } else {
          for (let i = 0; i < nodes.length; i++) {
            nodes[i].classList.add(elm.className + "-" + i);
          }

          for (let i = 0; i < nodes.length; i++) {
            if (elm.isPCOnly) {
              const checkBreakpoint = (e) => {
                if (e.matches) {
                  targets[i] = new Swiper(
                    "." + elm.className + "-" + i,
                    elm.options
                  );
                } else {
                  if (targets[i] !== null) {
                    targets[i].destroy(false, true);
                  }
                }
              };

              u.mq.addListener(checkBreakpoint);
              checkBreakpoint(u.mq);
            } else {
              new Swiper("." + elm.className + "-" + i, elm.options);
            }
          }
        }
      });
    },
    /**
     * @method smoothScroll
     * - スムーススクロール機能
     * @requires
     * - jQuery v3.6.0
     */
    smoothScroll: function () {
      //現在のページURLのハッシュ部分を取得
      const hash = location.hash;

      //ハッシュ部分がある場合の条件分岐
      if (hash) {
        //ページ遷移後のスクロール位置指定
        $("html, body").stop().scrollTop(0);
        //処理を遅らせる
        setTimeout(function () {
          //リンク先を取得
          const target = $(hash),
            //リンク先までの距離を取得
            position = target.offset().top;

          //指定の場所までスムーススクロール
          $("html, body").animate({ scrollTop: position }, 500, "swing");
        }, 500);
      }
    },
    /**
     * @method scrollTop
     * - ページ上部へ戻る機能
     */
    scrollTop: function () {
      const scrollTopBtn = document.getElementById("js-scroll-top");

      if (!scrollTopBtn) {
        return;
      }

      //監視点（透明）が画面外にいったらスクロールトップボタンを表示する
      const observerShowScrollTopBtn = new IntersectionObserver((entries) => {
        for (const e of entries) {
          const scrollTopBtn = document.getElementById("js-scroll-top");

          if (e.isIntersecting) {
            setTimeout(function () {
              scrollTopBtn.style.opacity = 0;
            }, 1);
            scrollTopBtn.classList.add("is-hide");
          } else {
            setTimeout(function () {
              scrollTopBtn.style.opacity = 1;
            }, 1);
            scrollTopBtn.classList.remove("is-hide");
          }
        }
      });

      observerShowScrollTopBtn.observe(
        document.getElementById("js-scroll-top-observer")
      );

      //フッター手前でスクロールトップボタンを固定する
      const options = {
        rootMargin: "0px 0px 0px 0px",
      };

      const observerFixScrollTopBtn = new IntersectionObserver((entries) => {
        for (const e of entries) {
          const scrollTopBtn = document.getElementById("js-scroll-top");

          if (e.isIntersecting) {
            scrollTopBtn.classList.remove("is-sticky");
            scrollTopBtn.classList.remove("product-buy-button-display");
          } else {
            scrollTopBtn.classList.add("is-sticky");
            scrollTopBtn.classList.add("product-buy-button-display");
          }
        }
      }, options);

      observerFixScrollTopBtn.observe(document.getElementById("js-footer"));

      //スクロールトップボタンのスクロール
      scrollTop("js-scroll-top");

      function scrollTop(el) {
        const target = document.getElementById(el);

        target.addEventListener("click", function () {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        });
      }
    },
  };
})();

/**
 * 商品閲覧履歴
 * @constructor
 * @param {string} accessToken StorefrontAPIのアクセストークン
 * @requires
 * - jQuery v3.6.0
 * - Handlebars v4.7.7
 */
const COMMON_RECENTLY_VIEWED_PRODUCTS = (function () {
  const u = new COMMON.Util();

  const _accessToken = Symbol();
  const _setAccessToken = Symbol();

  const _getCookiesData = Symbol();

  return class RecentlyViewedProducts {
    constructor(accessToken = null) {
      this[_setAccessToken](accessToken);
    }

    [_setAccessToken](accessToken) {
      this[_accessToken] = accessToken;
    }

    // クッキー情報の取得
    [_getCookiesData]() {
      return Cookies.get(u.viewProductRecentlyCookie).split(",");
    }

    /**
     * @method getProductsData
     * 閲覧履歴の取得・表示
     * @param {number} limit 表示件数
     * @param {string} targetClass ソースを挿入するクラス
     * @param {string} parentClass ソースを挿入した親クラス
     * @param {string} mode 表示形式（"slide"/"col"/null）
     */
    async getProductsData(limit, targetClass, parentClass, mode = null) {
      const currentCookies = this[_getCookiesData]();

      if (currentCookies) {
        const originalData = await u.ajaxGetShopifyProductData(
          this[_accessToken],
          u.makeQuery(currentCookies),
          limit
        );

        const processedData = u.convertShopifyProductData(
          originalData,
          currentCookies,
          mode
        );

        const html = await u.makeShopifyHTMLData(processedData);

        if (html) {
          $(targetClass).html("");
          $(targetClass).html(html);
        } else {
          $(parentClass).html("");
        }
      } else {
        $(parentClass).html("");
      }
    }
  };
})();

/**
 * 注目ワード表示
 * @constructor
 * @param {string} id awooAPIのID
 * @param {string} token awooAPIのアクセストークン
 * @requires
 * - jQuery v3.6.0
 * - Handlebars v4.7.7
 */
const COMMON_ATTENTION_WORDS = (function () {
  const _nununiId = Symbol();
  const _setNununiId = Symbol();
  const _token = Symbol();
  const _setToken = Symbol();

  const _makeHTMLFromData = Symbol();
  const _ajaxGetAttentionWords = Symbol();

  const attentionWordsTemplate = (tags) => {
    let html = '<ul class="attention-words__list">';

    for (let i = 0; i < tags.length; i++) {
      html += `
        <li class="attention-words__list__item">
          <a href="/pages/category?tags=${tags[i].link}">
            ${tags[i].text}
          </a>
        </li>
      `;
    }
    html += '</ul>';
    return html;
  };

  return class AttentionWords {
    constructor(id, token) {
      this[_setNununiId](id);
      this[_setToken](token);
    }

    [_setNununiId](id) {
      this[_nununiId] = id;
    }

    [_setToken](token) {
      this[_token] = token;
    }

    // 注目ワードの取得
    [_ajaxGetAttentionWords]() {
      return new Promise((resolve, reject) => {
        $.ajax({
          url: `https://api.awoo.org/nununi/v1/${this[_nununiId]}/populartags`,
          type: "GET",
          dataType: "json",
          contentType: "application/json",
          headers: {
            Authorization: `Bearer ${this[_token]}`,
          },
        })
          .done(function (data) {
            resolve(data.result);
          })
          .fail(function () {
            reject();
          });
      });
    }

    // HTMLソースに加工
    async [_makeHTMLFromData](tags) {
      return new Promise((resolve) => {
        if (tags.tags.length) {
          const html = attentionWordsTemplate(tags.tags);
          resolve(html);
          /*
          $.get(
            COMMON_SHOPIFY_PROPERTY.attentionWordsTemplateName,
            function (template) {
              const output = Handlebars.compile(template);
              resolve(output(tags));
            }
          );
          */
        } else {
          resolve(null);
        }
      });
    }

    /**
     * @method getAttentionsWords
     * 注目ワードの取得・表示
     * @param {string} targetClass ソースを挿入するクラス
     * @param {string} parentClass ソースを挿入した親クラス
     */
    async getAttentionsWords(targetClass, parentClass) {
      const tags = await this[_ajaxGetAttentionWords]();
      const html = await this[_makeHTMLFromData](tags);
      if (html) {
        $(targetClass).html("");
        $(targetClass).html(html);
      } else {
        $(parentClass).html("");
      }
    }
  };
})();

/**
 * @execution
 */
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    COMMON.module.initialize();
  });
})();
